export class TabsController {
  /* @ngInject */
  constructor($scope) {
    this.tabs = [];
    this.tabActions = [];

    let vm = this;
    $scope.$watch('vm.active', (newValue) => {
      let tab = _.find(this.tabs, ['name', newValue]);
      if (tab) {
        this.setActive(tab);
      }
    }, true);
  }

  addTab(tab) {
    tab.name = tab.name || `tab-${this.tabs.length}`;
    if (this.tabs.length == 0 || this.active == tab.name) {
      this.setActive(tab);
    }
    this.tabs.push(tab);
  }

  addTabAction(tabAction) {
    this.tabActions.push(tabAction);
  }

  setActive(tab) {
    this.tabs.forEach(tab => tab.active = false);
    tab.active = true;

    // trigger resize event to update tab content visibility
    setTimeout(() => window.dispatchEvent(new Event('resize')));
  }
}

export function TabsComponent() {
  return {
    template: `
    <div class="ng-hide" ng-transclude></div>
    <div class="c-tab__tabs">
      <label
        id="{{tab.name}}"
        class="c-tab__label {{tab.customClasses}}"
        ng-class="{'is-active': tab.active}"
        ng-click="vm.active=tab.name"
        ng-repeat="tab in vm.tabs"
        gg-tab-heading-transclude
      >
        {{tab.label}}
      </label>
      <label class="c-tab__action" ng-repeat="tabAction in vm.tabActions" gg-tab-action-transclude="tabAction"></label>
    </div>
    <div class="c-tab__panels" ng-if="!vm.hideDefaultPanels">
      <div class="c-tab__panel" ng-repeat="tab in vm.tabs" ng-class="{'is-active': tab.active}" gg-tab-content-transclude="tab"></div>
    </div>
    `,
    transclude: true,
    controller: TabsController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: {
      active: '=?',
      hideDefaultPanels: '='
    }
  };
};


export function TabActionComponent() {
  return {
    require: '^ggTabs',
    template: '',
    transclude: true,
    replace: true,
    controller: function () {
    },
    restrict: 'E',
    scope: {
      label: '@',
      name: '@'
    },
    link: function (scope, elm, attrs, tabsCtrl, transclude) {
      tabsCtrl.addTabAction(scope);
      scope.$transcludeFn = transclude;
    }
  };
};

export function TabComponent() {
  return {
    require: '^ggTabs',
    template: '',
    transclude: true,
    replace: true,
    controller: function () {
    },
    restrict: 'E',
    scope: {
      label: '@',
      name: '@',
      customClasses: '@'
    },
    link: function (scope, elm, attrs, tabsCtrl, transclude) {
      tabsCtrl.addTab(scope);
      scope.$transcludeFn = transclude;
    }
  };
};

function TabContentTranscludeComponent() {
  return {
    restrict: 'A',
    require: ['?^ggTabs'],
    link: function (scope, elm, attrs) {
      let tab = scope.$eval(attrs.ggTabContentTransclude);

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function (contents) {
        angular.forEach(contents, function (node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  }
}

function TabHeadingTranscludeComponent() {
  return {
    restrict: 'A',
    require: ['?^ggTab'],
    link: function (scope, elm) {
      scope.$watch('tab.headingElement', function (heading) {
        if (heading) {
          elm.hide();
          elm.parent().append(heading);
        }
      });
    }
  };
}

function TabActionTranscludeComponent() {
  return {
    restrict: 'A',
    require: ['?^ggTabAction'],
    link: function (scope, elm, attrs) {
      let tab = scope.$eval(attrs.ggTabActionTransclude);
      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function (contents) {
        angular.forEach(contents, function (node) {
          elm.append(node);
        });
      });
    }
  };
}

function isTabHeading(node) {
  return node.tagName && (
      node.tagName.toLowerCase() === 'gg-tab-heading'
    );
}

export default angular.module('gg-tabs', [])
  .directive('ggTabs', TabsComponent)
  .directive('ggTab', TabComponent)
  .directive('ggTabAction', TabActionComponent)
  .directive('ggTabContentTransclude', TabContentTranscludeComponent)
  .directive('ggTabHeadingTransclude', TabHeadingTranscludeComponent)
  .directive('ggTabActionTransclude', TabActionTranscludeComponent)



/** WEBPACK FOOTER **
 ** ./src/directives/tabs.js
 **/